function normalizeApiHost(url: string): string {
  return url.replace(/\/+$/, "");
}

function normalizeApiPrefix(prefix: string | undefined): string {
  const trimmedPrefix = prefix?.trim() ?? "";

  if (!trimmedPrefix) {
    return "";
  }

  return `/${trimmedPrefix.replace(/^\/+|\/+$/g, "")}`;
}

class Environment {
  get apiUrl(): string {
    return normalizeApiHost(process.env.NEXT_PUBLIC_API_URL || "http://localhost:4000");
  }

  get apiPrefix(): string {
    return normalizeApiPrefix(process.env.NEXT_PUBLIC_API_PREFIX || "v1");
  }

  get apiBaseUrl(): string {
    return this.apiEndpoint("");
  }

  apiEndpoint(path: string): string {
    const normalizedPath = path ? (path.startsWith("/") ? path : `/${path}`) : "";

    return `${this.apiUrl}${this.apiPrefix}${normalizedPath}`;
  }

  get mediaBaseUrl(): string {
    return normalizeApiHost(process.env.NEXT_PUBLIC_MEDIA_URL || this.apiUrl);
  }

  get siteUrl(): string {
    return normalizeApiHost(process.env.NEXT_PUBLIC_SITE_URL || "https://itshealer.com");
  }

  get isDevelopment(): boolean {
    return process.env.NODE_ENV === "development";
  }

  get isProduction(): boolean {
    return process.env.NODE_ENV === "production";
  }

  get isTest(): boolean {
    return process.env.NODE_ENV === "test";
  }

  get debugNetwork(): boolean {
    return process.env.NEXT_PUBLIC_DEBUG_NETWORK === "true";
  }

  get webVitalsEndpoint(): string {
    return process.env.NEXT_PUBLIC_WEB_VITALS_ENDPOINT || "/api/analytics/web-vitals";
  }

  get debugWebVitals(): boolean {
    return process.env.NEXT_PUBLIC_DEBUG_WEB_VITALS === "true";
  }

  get firebase() {
    return {
      apiKey: process.env.NEXT_PUBLIC_FIREBASE_API_KEY || "",
      authDomain: process.env.NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN || "",
      projectId: process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID || "",
      storageBucket: process.env.NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET || "",
      messagingSenderId: process.env.NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID || "",
      appId: process.env.NEXT_PUBLIC_FIREBASE_APP_ID || "",
    };
  }

  get fcmVapidKey(): string {
    return process.env.NEXT_PUBLIC_FIREBASE_VAPID_KEY || "";
  }
}

const Env = new Environment();

export default Env;
